"use client"
"use client";
import {
  input_default
} from "../chunk-ZSBPVRU4.js";
import {
  getPropByString
} from "../chunk-Q2O3JHTB.js";

// src/input/input-field.tsx
import {
  useFormContext,
  useFormState
} from "react-hook-form";
import { jsx } from "react/jsx-runtime";
var InputField = (props) => {
  const { register, getValues } = useFormContext();
  const { errors } = useFormState();
  const error = getPropByString(errors, props.name);
  const { ref, ...registerRest } = register(props.name, props.rules);
  return /* @__PURE__ */ jsx(input_default, { ...registerRest, ref, ...props, error: error?.message });
};
var input_field_default = InputField;
export {
  input_field_default as default
};
